export function getInvoiceIssueDate(value) {
  const date = String(value || "").slice(0, 10);
  if (!/^\d{4}-\d{2}-\d{2}$/.test(date)) return "";
  const parsed = new Date(`${date}T00:00:00Z`);
  return !Number.isNaN(parsed.getTime()) && parsed.toISOString().slice(0, 10) === date
    ? date
    : "";
}

export function sortInvoicesByIssueDate(invoices, direction = "desc") {
  return [...invoices].sort((a, b) => {
    const aDate = getInvoiceIssueDate(a?.data_emitere);
    const bDate = getInvoiceIssueDate(b?.data_emitere);
    // Keep missing dates last in either direction and equal dates in their existing order.
    if (!aDate) return bDate ? 1 : 0;
    if (!bDate) return -1;
    return direction === "asc" ? aDate.localeCompare(bDate) : bDate.localeCompare(aDate);
  });
}
